// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bi6J","fullView":"styles_fullView__Igij9"};